import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field, useField } from 'react-final-form';

import FormItem from 'common/Form/components/FormItem';
import { required as isRequired } from 'utils/validation';
import PhoneNumberInput from './components/PhoneNumberInput';

/**
 * @typedef {{
 *  localName?: string,
 *  prefixName?: string,
 *  defaultCountry?: string,
 *  required?: boolean,
 * } & import('react-phone-number-input').Props} PhoneProps
 */

/** @type {React.FC<PhoneProps>} */
const PhoneInput = ({ localName, prefixName, defaultCountry, required, ...rest }) => {
  const { input: prefixInput } = useField(prefixName, { subscription: { value: true } });

  const fieldProps = { value: true, ...(required ? { error: true, touched: true } : {}) };

  const handleValidation = value => (required ? isRequired(value) : undefined);

  const handleCountryChange = (_, prefix) => {
    prefixInput.onChange(prefix);
  };

  return (
    <Field name={localName} subscription={fieldProps} validate={handleValidation}>
      {({ input }) => (
        <FormItem title={<FormattedMessage id="web.phonenumber" defaultMessage="Phone" />} data-cy="input-phone">
          <PhoneNumberInput
            {...input}
            defaultCountry={defaultCountry}
            addInternationalOption={false}
            onCountryChange={handleCountryChange}
            {...rest}
          />
        </FormItem>
      )}
    </Field>
  );
};

export default PhoneInput;
